var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnterpriseCloudPartners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58.04,
    viewBox: "0 0 58 58.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(-759.5 -1538.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 58,
    height: 58,
    transform: "translate(759.5 1539)",
    fill: "none",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M806.666,1574.341a1,1,0,0,1-.2-1.978,8.357,8.357,0,1,0-3.537-16.334,1,1,0,0,1-1.19-1.211,10.671,10.671,0,0,0,.3-2.53,10.881,10.881,0,0,0-21.114-3.7,1,1,0,0,1-1.493.491,4.936,4.936,0,0,0-7.47,5.527,1,1,0,0,1-.834,1.275,8.356,8.356,0,0,0-.606,16.482,1,1,0,0,1-.392,1.959,10.354,10.354,0,0,1-.315-20.233,6.936,6.936,0,0,1,9.674-7.249,12.878,12.878,0,0,1,24.547,5.448,12.7,12.7,0,0,1-.1,1.563c.294-.026.585-.039.871-.039a10.357,10.357,0,0,1,2.045,20.51A1.031,1.031,0,0,1,806.666,1574.341Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M794.806,1583.465H782.194a3.19,3.19,0,0,1-3.186-3.187v-12.611a3.19,3.19,0,0,1,3.186-3.187h12.612a3.19,3.19,0,0,1,3.186,3.187v12.611A3.19,3.19,0,0,1,794.806,1583.465Zm-12.612-16.988a1.191,1.191,0,0,0-1.189,1.19v12.611a1.191,1.191,0,0,0,1.189,1.19h12.612a1.191,1.191,0,0,0,1.189-1.19v-12.611a1.191,1.191,0,0,0-1.189-1.19Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M802.119,1570.2h-5.127a1,1,0,0,1,0-2h5.127a1,1,0,0,1,0,2Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M802.119,1574.971h-5.127a1,1,0,0,1,0-2h5.127a1,1,0,0,1,0,2Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M802.119,1579.74h-5.127a1,1,0,0,1,0-2h5.127a1,1,0,0,1,0,2Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M783.731,1566.479a1,1,0,0,1-1-1v-5.126a1,1,0,1,1,2,0v5.126A1,1,0,0,1,783.731,1566.479Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M788.5,1566.479a1,1,0,0,1-1-1v-5.126a1,1,0,0,1,2,0v5.126A1,1,0,0,1,788.5,1566.479Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M793.269,1566.479a1,1,0,0,1-1-1v-5.126a1,1,0,1,1,2,0v5.126A1,1,0,0,1,793.269,1566.479Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M780.008,1579.74h-5.127a1,1,0,0,1,0-2h5.127a1,1,0,0,1,0,2Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M780.008,1574.971h-5.127a1,1,0,0,1,0-2h5.127a1,1,0,0,1,0,2Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M780.008,1570.2h-5.127a1,1,0,0,1,0-2h5.127a1,1,0,0,1,0,2Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M793.269,1588.59a1,1,0,0,1-1-1v-5.126a1,1,0,0,1,2,0v5.126A1,1,0,0,1,793.269,1588.59Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M793.269,1592.77a1,1,0,0,1-1-1v-.126a1,1,0,1,1,2,0v.126A1,1,0,0,1,793.269,1592.77Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M788.5,1592.77a1,1,0,0,1-1-1v-.126a1,1,0,0,1,2,0v.126A1,1,0,0,1,788.5,1592.77Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M783.731,1592.77a1,1,0,0,1-1-1v-.126a1,1,0,1,1,2,0v.126A1,1,0,0,1,783.731,1592.77Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M793.269,1596.6a1,1,0,0,1-1-1v-.126a1,1,0,1,1,2,0v.126A1,1,0,0,1,793.269,1596.6Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M788.5,1596.6a1,1,0,0,1-1-1v-.126a1,1,0,0,1,2,0v.126A1,1,0,0,1,788.5,1596.6Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M783.731,1596.6a1,1,0,0,1-1-1v-.126a1,1,0,1,1,2,0v.126A1,1,0,0,1,783.731,1596.6Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M788.5,1588.59a1,1,0,0,1-1-1v-5.126a1,1,0,0,1,2,0v5.126A1,1,0,0,1,788.5,1588.59Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M783.731,1588.59a1,1,0,0,1-1-1v-5.126a1,1,0,0,1,2,0v5.126A1,1,0,0,1,783.731,1588.59Z",
    fill: "#847dff",
    stroke: "#847dff",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M787.755,1577.728a.65.65,0,0,1-.65-.649v-4.542a1.118,1.118,0,1,0-2.237,0v4.542a.65.65,0,0,1-1.3,0v-4.542a2.418,2.418,0,1,1,4.836,0v4.542A.65.65,0,0,1,787.755,1577.728Z",
    fill: "#847dff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M787.755,1574.771h-3.537a.649.649,0,1,1,0-1.3h3.537a.649.649,0,0,1,0,1.3Z",
    fill: "#847dff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M791.709,1577.417a.65.65,0,0,1-.65-.65v-5.661a.649.649,0,0,1,1.3,0v5.661A.65.65,0,0,1,791.709,1577.417Z",
    fill: "#847dff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M792.975,1571.756h-2.533a.649.649,0,0,1,0-1.3h2.533a.649.649,0,1,1,0,1.3Z",
    fill: "#847dff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M792.975,1577.417h-2.533a.65.65,0,0,1,0-1.3h2.533a.65.65,0,1,1,0,1.3Z",
    fill: "#847dff"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseCloudPartners);
export default __webpack_public_path__ + "static/media/enterprise-cloud-partners.b8f1b71fe083b4670da47a7b19f2f8a8.svg";
export { ForwardRef as ReactComponent };